import type { CalendarEvent } from "../Models/Domain";

import CalendarEventTransformer from "@/Modules/Transformers/Calendars/Event";
import { deleteEvent } from "@/Services/TherapyApi/Calendars";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import useCalendarsStore from "../Store";

const RemoveEventActionHandler = async (
  event: Omit<CalendarEvent, "isEditable">
): Promise<CalendarEvent | undefined> => {
  const calendarsStore = useCalendarsStore();

  const resp = await deleteEvent(event.calendarUuid, event.uuid);

  if (isApiError(resp)) return undefined;

  const calendarEvent = CalendarEventTransformer.toDomain(resp);

  calendarsStore.events = calendarsStore.events.filter((e) => e.uuid !== calendarEvent.uuid);

  return calendarEvent;
};

export default RemoveEventActionHandler;
